<button class="btn btn-sm border-white ms-1 px-3"
  [class.btn-primary]="!headerFilter.isInvalid && !headerFilter.isDisabled"
  [class.btn-secondary]="!headerFilter.isInvalid && headerFilter.isDisabled"
  [class.btn-danger]="headerFilter.isInvalid">

  <!-- Icon container, shown on hover -->
  <span class="icon-container">
    <!-- Left side: Enable/Disable Icon (First 50%) -->
    <span class="icon-left">
      <span 
        (click)="toggleHeaderFilterIsDisable()"
        ngbTooltip="{{getTooltipText()}}"
        container="body"
        class="icon-padding"
        placement="bottom">
        <i *ngIf="headerFilter.isDisabled" class="fa-light fa-eye"></i>
        <i *ngIf="!headerFilter.isDisabled" class="fa-light fa-eye-slash"></i>
      </span>
    </span>

    <!-- Separator -->
    <span class="separator"></span>

    <!-- Right side: Delete Icon (Second 50%) -->
    <span class="icon-right">
      <!-- Delete Icon -->
      <span 
        (click)="removeHeaderFilter()"
        ngbTooltip="Remove filter"
        container="body"
        class="icon-padding delete-icon"
        placement="bottom">
        <i class="fa-light fa-xmark"></i>
      </span>
    </span>
  </span>

  <!-- Filter label and value (only visible when not hovered) -->
  <div class="filter-label">
      <!-- Invalid Icon -->
    <i *ngIf="headerFilter.isInvalid" class="fa-light fa-circle-exclamation"></i>
    <span>
      <strong>{{headerFilter.label}}:</strong> {{headerFilter.valueToDisplay | truncate: 20: '...' }}
    </span>
  </div>
</button>
